import { useEffect } from "react";

const extractValue = (val) =>
  typeof val === "object" && val != null && "value" in val ? val.value : val;

const isSkippedValue = (val, skipValues) =>
  skipValues.some((skip) => String(skip) === String(val));

/**
 * Validates if value(s) exist in a list of options.
 * Clears orphaned values (e.g. when referenced entity was deleted from DB).
 */
const validateOptionValueExists = (value, options, onChange, skipValues) => {
  if (Array.isArray(value)) {
    const validValues = value.filter((val) => {
      const valToCheck = extractValue(val);
      if (isSkippedValue(valToCheck, skipValues)) {
        return true;
      }
      return options.some(
        (option) => String(option.value) === String(valToCheck),
      );
    });

    if (validValues.length !== value.length) {
      onChange(validValues.length ? validValues : null);
    }
    return;
  }

  const valueToCheck = extractValue(value);
  if (
    valueToCheck == null ||
    valueToCheck === "" ||
    isSkippedValue(valueToCheck, skipValues)
  ) {
    return;
  }

  const isValidValue = options.some(
    (option) => String(option.value) === String(valueToCheck),
  );
  if (!isValidValue) {
    onChange(null);
  }
};

export const useValidateOptionValue = (
  value,
  options,
  onChange,
  { enabled = false, isLoading = false, skipValues = ["-1"] } = {},
) => {
  useEffect(() => {
    if (!enabled || isLoading || !options.length || !onChange) {
      return;
    }
    validateOptionValueExists(value, options, onChange, skipValues);
  }, [value, options, onChange, enabled, isLoading, skipValues]);
};
